import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { Grid } from "@material-ui/core";
import Header from "../app/Header";
import useStyles from "../content/styles";
import { PageContainer } from "../app/Page";

export default function ErrorPage() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container item direction="column">
      <Grid container item>
        <Header />
      </Grid>
      <Grid item>
        <PageContainer>
          <span className={classes.text}>
            <Trans>{t("app.erroroccurred")}</Trans>
          </span>
        </PageContainer>
      </Grid>
    </Grid>
  );
}
